import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { addMessageBox } from '../../../redux/actions/messageBoxesActions';
import { thunkSitDown } from '../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { Button } from '../pixiComponents/button';
/**
 * On the server side, this value corresponds to the max of the new player chip amount and the rebuy chip amount.
 * TODO: Make sure this is kept in sync with server changes or send them in a server outbound.
 */
const SHORT_CHIPS_BUY_IN_THRESHOLD = 2500;
export const SitButton = ({ seatIndex }) => {
    const dispatch = useAppDispatch();
    const hasBuyInRange = useAppSelector((state) => state.poker.hasBuyInRange);
    const minBuyIn = useAppSelector((state) => state.poker.minBuyIn);
    const maxBuyIn = useAppSelector((state) => state.poker.maxBuyIn);
    const requestedBuyIn = useAppSelector((state) => state.poker.requestedBuyIn);
    const rememberRequestedBuyIn = useAppSelector((state) => state.poker.rememberRequestedBuyIn);
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    const lastChipStack = useAppSelector((state) => state.poker.lastChipStack);
    const currency = useAppSelector((state) => state.poker.currency);
    const availableCurrencyAmount = useAppSelector((state) => currency === 'jacks' ? state.selfData.numJacks : state.selfData.numChips);
    const socketSend = useSocketSend();
    function isSittingWithImplicitBuyIn() {
        if (!hasBuyInRange) {
            // also true for any tourney
            return true;
        }
        if (currency === 'chips' &&
            availableCurrencyAmount !== undefined &&
            availableCurrencyAmount < SHORT_CHIPS_BUY_IN_THRESHOLD &&
            minBuyIn &&
            minBuyIn <= SHORT_CHIPS_BUY_IN_THRESHOLD) {
            // Room has a buy-in range, and both the player's chips and the min buy-in are within the threshold that allows
            // any new, or rebuying, player to sit and play at these stakes.
            // Sit with an "implicit" buy-in amount rather than let the client decide the exact amount.
            // TODO: Consider moving this logic to exist only on the server, since it is somewhat duplicated on client as well.
            return true;
        }
        return false;
    }
    function onClick() {
        if (isSittingWithImplicitBuyIn()) {
            dispatch(thunkSitDown(seatIndex, undefined, undefined, socketSend));
            return;
        }
        if (lastChipStack && maxBuyIn && requestedBuyIn && lastChipStack >= maxBuyIn) {
            // has a buy-in range but player already has a last chip stack from last time sitting, which is >= the max
            // buy-in, so it doesn't matter what the set buy-in amount is, because it won't be used, don't show the set buy-in modal
            dispatch(thunkSitDown(seatIndex, requestedBuyIn, undefined, socketSend));
            return;
        }
        if (!requestedBuyIn || !rememberRequestedBuyIn) {
            // has a buy-in range but requested buy-in amount has not been set (or was not remembered)
            dispatch(addMessageBox({ type: 'set-buy-in', seatIndex }));
            return;
        }
        dispatch(thunkSitDown(seatIndex, requestedBuyIn, undefined, socketSend));
    }
    return (_jsx(Button, { pixiObjectData: { type: 'sit-button', seatIndex }, onClick: onClick, bounds: bounds, labelProperties: { label: 'SIT', bitmapTextStyleType: 'button-label' }, shrinkToFit: true }));
};
